module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', {
    attrs: {
      "name": "video-message-details"
    }
  }, [_c('bc-navbar'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "layout_fullwidth_padding"
  }, [_c('div', {
    staticClass: "loader",
    class: {
      none: !_vm.isRequestActive
    }
  }, [_c('looping-rhombuses-spinner', {
    attrs: {
      "animation-duration": 2500,
      "rhombus-size": 15,
      "color": "#f9f300"
    }
  })], 1), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.back
    }
  }, [_c('img', {
    staticClass: "back_image_button",
    attrs: {
      "src": "/static/images/icons/black/back.png",
      "alt": "",
      "title": ""
    }
  })]), _vm._v(" "), (_vm.selectedVideoMessage) ? _c('div', [_c('h3', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v(_vm._s(_vm.selectedVideoMessage.title))]), _vm._v(" "), (_vm.selectedVideoMessage.youTubeId) ? _c('div', {
    attrs: {
      "id": "youtubeIframe"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedVideoMessage.url && !_vm.selectedVideoMessage.youTubeId) ? _c('video', {
    attrs: {
      "id": "player",
      "controls": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.selectedVideoMessage.message)
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.selectedVideoMessage.backgroundImageUrl
    }
  }), _vm._v(" "), _c('h6', [_c('i', {
    staticClass: "fa fa-calendar-check-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.getDateAndTime(_vm.selectedVideoMessage.sendDate)))]), _vm._v(" "), _c('a', {
    staticClass: "button_full btyellow external",
    style: (_vm.borderStyle),
    attrs: {
      "href": _vm.selectedVideoMessage.backgroundSiteUrl
    },
    on: {
      "click": function($event) {
        return _vm.redirectTo(_vm.selectedVideoMessage.backgroundSiteUrl)
      }
    }
  }, [_vm._v("\n                Read More\n            ")])]) : _vm._e()])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1a2b32f1", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a2b32f1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/pages/video-message/video-message-details.vue
// module id = 743
// module chunks = 0